module.exports = (__webpack_require__(2))(20);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/BrowserWidget.js from dll-reference girder_plugin_slicer_cli_web
// module id = 58
// module chunks = 0